import * as _ from "lodash";
import * as React from "react";
import {WindowKey} from "@bizform/type/model/model/WindowKey.model";
import {ExceptionType} from "@bizform/type/model/model/Exception.model";
import {WrongRequest} from "@bizform/type/model/rest_api/_BaseRestApi.model";
import {
    AjaxService,
    DataStorage,
    ExceptionHandler,
    FormStateService,
    ProxyBaseClass
} from "@bizform/core/dist/js/bizflow/core.min";


@ProxyBaseClass("root")
class SignatureHelperUtil {
    destroyed: boolean;

    makeValue(imageValue: string, metaInfo: string, timestamp: string): string {
        if (metaInfo && imageValue) {
            const metaInfos = metaInfo.split(" ");
            if (Array.isArray(metaInfos) && metaInfos.length) {
                const rState = DataStorage.configuration.readOnlyState;
                const meta = {};
                for (let i = 0; i < metaInfos.length; i++) {
                    _.set(meta, metaInfos[i], (metaInfos[i] === "queryString" ? FormStateService.getQueryString(window[WindowKey.APPLICATIONID], window[WindowKey.FORMID]) : _.get(rState, metaInfos[i])));
                }
                if (timestamp) {
                    _.set(meta, "eSignTimestamp", timestamp);
                }
                return imageValue + "@" + btoa(JSON.stringify(meta));
            }
        }
        return imageValue;
    }

    async adjustImageSize(e: any): Promise<void> {
        const rate = e.target.parentElement.offsetWidth / e.target.parentElement.offsetHeight;
        const iRate = e.target.width / e.target.height;
        if (iRate <= rate) {
            e.target.setAttribute("height", "100%");
            e.target.setAttribute("width", "auto");
            e.target.style.maxHeight = "100%";
        } else {
            e.target.setAttribute("height", "auto");
            e.target.setAttribute("width", "100%");
            e.target.style.maxWidth = "100%";
        }
        e.target.style.opacity = "1";
    }

    readSign(attr: any, callback: Function) {
        const d: any = {};
        if (attr) {
            if (attr.signatureColor) {
                d.signatureColor = attr.signatureColor.replace(/^#/, "0x");
            }
            if (attr.signatureFont && attr.signatureFont.trim()) {
                d.signatureFont = attr.signatureFont.trim();
            }
            if (attr.signatureFontSize) {
                d.signatureFontSize = attr.signatureFontSize;
            }
            if (attr.signatureMaxWidth) {
                d.signatureMaxWidth = attr.signatureMaxWidth;
            }
            if (attr.timestampColor) {
                d.timestampColor = attr.timestampColor.replace(/^#/, "0x");
            }
            if (attr.timestampFont && attr.timestampFont.trim()) {
                d.timestampFont = attr.timestampFont.trim();
            }
            if (attr.timestampFontSize) {
                d.timestampFontSize = attr.timestampFontSize;
            }
            if (attr.timestampMaxWidth) {
                d.timestampMaxWidth = attr.timestampMaxWidth;
            }
            if (attr.timestampString) {
                d.timestampString = attr.timestampString;
            }
            if (attr.datetimeFormat) {
                d.datetimeFormat = attr.datetimeFormat;
            }
        }
        AjaxService.post(
            DataStorage.serviceOrgPath + "user/esignature/myesignature.json",
            d
        ).then(
            (response: any) => {
                try {
                    callback(response);
                } catch (e) {
                    callback(null, true);
                }
            }
        ).catch(
            (e: WrongRequest) => {
                ExceptionHandler.alert(ExceptionType.ALERT, e);
                if (callback) {
                    callback(null, true);
                }
            }
        );
    }

    destruction() {
    }
}

export const SignatureHelper: SignatureHelperUtil = new SignatureHelperUtil();
